// extracted by mini-css-extract-plugin
export var active = "Profile-module--active--1c783";
export var btn = "Profile-module--btn--0e817";
export var btnActive = "Profile-module--btnActive--ec9c1";
export var profile = "Profile-module--profile--4a0bb";
export var profile__imgWrapper = "Profile-module--profile__imgWrapper--638bb";
export var profile__info = "Profile-module--profile__info--62887";
export var profile__picture = "Profile-module--profile__picture--aee2d";